import { IAlertButtonProps, INotificationProps } from '../../../../infrastructure/alerts';
import { ButtonModifier } from '../../../../infrastructure/helpers';

enum AlertType {
    confirm,
    alert
}

/**
 * used by alerts host to describe state of particular alert
 */
interface ISingleAlert<T> {
    popupProps: T;
    type: AlertType;
    alertKey: string;
    isRelatedToEvent?: boolean;
}

interface ISingleNotification {
    popupProps: INotificationProps;
    alertKey: string;
    isRelatedToEvent?: boolean;
}

interface IAlertComponentProps<T> {
    popupProps: T;
    closeHandler: () => void;
}

const applyDefaultsToButtonProps = (props: IAlertButtonProps, defaultText: string, closePopupHandler: () => void) => {
    const buttonText = props?.text || defaultText;
    const buttonModifier: ButtonModifier[] = ['fat'];
    if (props?.modifier) {
        buttonModifier.push(props.modifier);
    }

    const clickHandler = () => {
        closePopupHandler();
        if (props?.handler && !props?.disableClickHandlerForOverlay) {
            props.handler();
        }
    };

    return {
        modifiers: buttonModifier,
        text: buttonText,
        clickHandler: clickHandler,
        hideCloseButtonInAlertPopup: props?.hideCloseButtonInAlertPopup
    };
};

export { ISingleAlert, IAlertComponentProps, ISingleNotification, AlertType, applyDefaultsToButtonProps };
